import ScrollUpButton from './ScrollUpButton';

export default ScrollUpButton;
